jQuery(function($){
	// init
	var currentTooltip = null;

	// init provinces
	var oProvinces = {
		"NL-OV": 'Overijssel',
		"NL-FR": 'Friesland',
		"NL-UT": 'Utrecht',
		"NL-GE": 'Gelderland',
		"NL-FL": 'Flevoland',
		"NL-NH": 'Noord-Holland',
		"NL-ZE": 'Zeeland',
		"NL-ZH": 'Zuid-Holland',
		"NL-GR": 'Groningen',
		"NL-DR": 'Drenthe',
		"NL-NB": 'Noord-Brabant',
		"NL-LI": 'Limburg'
	}

	var oProvincePatterns = {};
	for(var key in oProvinces)
	{
		oProvincePatterns[key] = 'pattern';
	}

	function ShowTooltip(text, x, y) {
		if(text != currentTooltip) {
			// hide the rest
			HideTooltips();

			// create new tooltip
			var $tooltip = $('<label class="map-tooltip" />');
			var $tooltip_svg_start = '<div class="svg-container"><svg class="label-' + text + '">';
			var $tooltip_svg_use = '<use xlink:href="/wp-content/themes/gaystraightalliance/dist/svg/sprite.svg#label-' + text + '">';
			var $tooltip_svg_end = '</svg></div>';
			var $tooltip_svg = $($tooltip_svg_start + $tooltip_svg_use + $tooltip_svg_end);
			$tooltip.appendTo("body");
			$tooltip.append($tooltip_svg);
			currentTooltip = text;
		} else {
			var $tooltip = $(".map-tooltip");
		}

		// update position
		$tooltip.css({
			left: x,
			top: y,
		});
	}

	function HideTooltips() {
		currentTooltip = null;
		$(".map-tooltip").remove();
	}

	$('.jvectormap').each(function(){
		// load markers for non-mobile
		var markers = OD_VectorMap_Markers;
		if($(window).width() < 480) {
			markers = null;
		}

		// init
		var $container = $(this);
		var lastRegion = null;
		var colorBlack = "#000000";
		var colorBlue = "#25d5fd";
		var colorYellow = "#fefd38";
		var map = new jvm.Map({
			container: $container,
			zoomOnScroll: false,
			markers: markers,
			map: 'nl_merc',
			backgroundColor: "transparent", 
			regionStyle: {
				initial: {
					fill: colorBlue,
					"fill-opacity": 1,
					stroke: colorBlack,
					"stroke-width": 6,
					"stroke-opacity": 1
				},
				hover: {
					"fill-opacity": 1,
					fill: colorYellow,
					cursor: 'pointer'
				},
				selected: {
					fill: colorYellow
				}
			},
			series: {
				markers: [{
					attribute: 'image',
					scale: {
						'small1': '/wp-content/themes/gaystraightalliance/dist/svg/icon-dot-small1.svg',
						'small2': '/wp-content/themes/gaystraightalliance/dist/svg/icon-dot-small2.svg',
						'small3': '/wp-content/themes/gaystraightalliance/dist/svg/icon-dot-small3.svg'
					},
					values: OD_VectorMap_values 
				}]
			},

			onRegionOver: function(e, region){
				lastRegion = region;
				map.clearSelectedRegions();
				map.setSelectedRegions(lastRegion);	
				
				var text = oProvinces[region];
				
				// show tooltip
				$(this).mousemove(function(i){
					// show tooltip
					ShowTooltip(text, i.pageX, i.pageY);
				});
			},
			onRegionOut: function(){
				$(this).unbind("mousemove");
				map.clearSelectedRegions();
				HideTooltips();
			},
			onMarkerOut: function(){
				// empty
			},
			onMarkerOver: function(e, marker){
				map.setSelectedRegions(lastRegion);
				text = oProvinces[lastRegion];

				// show tooltip
				$(this).mousemove(function(i){
					// calculate location of tooltip to cursor position
					ShowTooltip(text, i.pageX, i.pageY);
				});
			},
			onMarkerClick: function(e, marker){
				// empty
			},
			onRegionClick: function(e, region) {
				// application page: return tooltip value to the application
				if($("body").hasClass("page-template-content-application")) {
					var text = oProvinces[region];
					// pass region name to application
					oApplication.SearchFund(text);
				}
				// normal behavior: follow the link
				else {
					window.location.href = OD_VectorMap_ProvinceLinks[oProvinces[region]];
				}
			},
		});
	});
});
